// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.zone-type-picker {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(5, 7, 8, 0.82);
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
}
.zone-type-picker__panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  width: 380px;
  max-width: 90vw;
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.zone-type-picker__panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .zone-type-picker__panel {
    animation: none;
  }
}
.zone-type-picker__header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.zone-type-picker__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.zone-type-picker__subtitle {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin-top: 4px;
}
.zone-type-picker__select {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  font-size: 14px;
}
.zone-type-picker__select:focus {
  outline: none;
  border-color: var(--gold-main);
}
.zone-type-picker__select::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.zone-type-picker__select:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 1px;
}
.zone-type-picker__label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  margin-bottom: -8px;
}
.zone-type-picker__input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
}
.zone-type-picker__input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.zone-type-picker__input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.zone-type-picker__check {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  font-size: 14px;
  line-height: 1.4;
  color: #aeaba2;
  cursor: pointer;
}
.zone-type-picker__check input {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  accent-color: var(--gold-main);
  cursor: pointer;
}
.zone-type-picker__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
}
.zone-type-picker__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.zone-type-picker__button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.zone-type-picker__button:active:not(:disabled) {
  transform: translateY(1px);
}
.zone-type-picker__button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.zone-type-picker__button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.zone-type-picker__button--cancel {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.zone-type-picker__button--cancel:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.zone-type-picker__button--confirm {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.zone-type-picker__button--confirm:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/ZoneTypePicker/ZoneTypePicker.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAJA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,yDDiBU;EChBV,cDOK;ACDP;AAJE;EDiBA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC3JE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAYJ;ADDE;EAAI,sBAAA;ACIN;ADyIE;EChKA;IDgK0C,eAAA;ECrI1C;AACF;AAjBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAmBJ;AAhBE;EDuBA,kDA3BW;EA4BX,gBAAA;EACA,eCxBqB;EDyBrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ACoCP;AApBE;EDkCA,eAAA;EACA,gBAAA;EACA,cAlDO;ECgBL,eAAA;AAwBJ;AArBE;ED+FA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECrGE,eAAA;AA+BJ;ADwEE;EAAU,aAAA;EAAe,8BAAA;ACpE3B;ADqEE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC9D1G;AAxCI;EACE,oCAAA;EACA,mBAAA;AA0CN;AAtCE;EDyBA,eAAA;EACA,gBAAA;EACA,cAzDO;ECgCL,mBAAA;AA0CJ;AAvCE;EDgFA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ACtCF;ADwCE;EAAU,aAAA;EAAe,8BAAA;ACpC3B;ADqCE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC9B1G;AAvDE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cD/CK;ECgDL,eAAA;AAyDJ;AAvDI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,eAAA;AAyDN;AArDE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AAuDJ;AApDE;EDJA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;AC2DF;ADzDE;EAAyB,qCAAA;EAAuC,8BAAA;AC6DlE;AD5DE;EAA0B,0BAAA;AC+D5B;AD9DE;EAAa,YAAA;EAAc,mBAAA;ACkE7B;ADjEE;EAAkB,oCAAA;EAAsC,mBAAA;ACqE1D;AAlFI;EDiCF,cArGO;EAsGP,uBAAA;EACA,yBAAA;ACoDF;ADlDE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACuDhF;AA3FI;EDgBF,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC8EF;AD5EE;EAAyB,6BAAA;EAA+B,+BAAA;ACgF1D","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Zone type prompt: centred modal over a dimmed backdrop.\n// One primary action (confirm), neutral cancel.\n\n.zone-type-picker {\n  position: fixed;\n  inset: 0;\n  z-index: 60;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(5, 7, 8, 0.82);\n  font-family: ink.$font-text;\n  color: ink.$text;\n\n  &__panel {\n    @include ink.panel;\n    @include ink.enter;\n    width: 380px;\n    max-width: 90vw;\n    padding: 22px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  &__title {\n    @include ink.title(22px);\n  }\n\n  &__subtitle {\n    @include ink.hint;\n    margin-top: 4px;\n  }\n\n  &__select {\n    @include ink.field;\n    font-size: 14px;\n\n    &:focus-visible {\n      outline: 2px solid var(--gold-light);\n      outline-offset: 1px;\n    }\n  }\n\n  &__label {\n    @include ink.label;\n    margin-bottom: -8px;\n  }\n\n  &__input {\n    @include ink.field;\n  }\n\n  // Wraps rather than truncating: the preview of the sentence is the point of\n  // the checkbox, so cutting it off would defeat it.\n  &__check {\n    display: flex;\n    align-items: flex-start;\n    gap: 9px;\n    font-size: 14px;\n    line-height: 1.4;\n    color: ink.$text-2;\n    cursor: pointer;\n\n    input {\n      width: 16px;\n      height: 16px;\n      margin-top: 2px;\n      accent-color: var(--gold-main);\n      cursor: pointer;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 4px;\n  }\n\n  &__button {\n    @include ink.button;\n\n    &--cancel { @include ink.button-quiet; }\n    &--confirm { @include ink.button-primary; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
